import { render, staticRenderFns } from "./PassedModal.vue?vue&type=template&id=9731adc4&scoped=true"
import script from "./PassedModal.vue?vue&type=script&lang=js"
export * from "./PassedModal.vue?vue&type=script&lang=js"
import style0 from "./PassedModal.vue?vue&type=style&index=0&id=9731adc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9731adc4",
  null
  
)

export default component.exports